import React from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { Email } from "@mui/icons-material";
import type { ClubMember, Handler } from "./types";

type MemberLike = ClubMember | Handler;

interface MemberContentProps {
  member: MemberLike;
  avatarColor: string;
}

export const MemberContent: React.FC<MemberContentProps> = ({
  member,
  avatarColor,
}) => (
  <>
    <ListItemAvatar sx={{ minWidth: { xs: 44, sm: 56 } }}>
      <Avatar
        sx={{
          bgcolor: avatarColor,
          width: { xs: 32, sm: 40 },
          height: { xs: 32, sm: 40 },
          fontSize: { xs: "0.875rem", sm: "1.25rem" },
        }}
      >
        {member.handler_name.charAt(0)}
      </Avatar>
    </ListItemAvatar>
    <ListItemText
      primary={member.handler_name}
      primaryTypographyProps={{
        sx: { wordBreak: "break-word" },
      }}
      secondary={
        <Box
          component="span"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            mt: 0.5,
            wordBreak: "break-all",
          }}
        >
          <Email sx={{ fontSize: 14, flexShrink: 0 }} />
          <Box component="span" sx={{ minWidth: 0 }}>
            {member.email_address}
          </Box>
        </Box>
      }
    />
  </>
);

interface MemberListItemProps {
  member: MemberLike;
  avatarColor: string;
  action?: React.ReactNode;
}

const MemberListItem: React.FC<MemberListItemProps> = ({
  member,
  avatarColor,
  action,
}) => (
  <ListItem secondaryAction={action}>
    <MemberContent member={member} avatarColor={avatarColor} />
  </ListItem>
);

export default MemberListItem;
